import React, { useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { useBranding } from "@/lib/branding";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import PoweredBy from "@/components/PoweredBy";

export default function ForgotPassword() {
  const { branding } = useBranding();
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
      toast.success("Request sent");
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Something went wrong");
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen bg-background paper-texture grid place-items-center p-6">
      <form onSubmit={submit} className="max-w-md w-full bg-card border border-border rounded-md p-8" data-testid="forgot-password-form">
        <div className="label-caps mb-2">{branding.brand_name}</div>
        <h1 className="font-serif text-4xl mb-2">Forgot your password?</h1>
        <p className="text-sm text-muted-foreground mb-6">
          {sent
            ? "If we found your account, you'll receive a reset link by email shortly. If it doesn't arrive, your instructor can also share one manually."
            : "Enter your email — we'll send you a reset link right away."}
        </p>

        {!sent && (
          <div className="space-y-4">
            <div>
              <Label htmlFor="fp-email">Email</Label>
              <Input id="fp-email" data-testid="forgot-email-input" type="email" value={email} onChange={e => setEmail(e.target.value)} required />
            </div>
            <Button type="submit" disabled={loading} className="w-full" data-testid="forgot-submit-btn">
              {loading ? "Sending…" : "Request reset"}
            </Button>
          </div>
        )}
        <div className="text-center mt-6">
          <Link to="/login" className="text-xs underline text-muted-foreground" data-testid="forgot-back-login">Back to sign in</Link>
        </div>
        <PoweredBy className="mt-6 text-center" />
      </form>
    </div>
  );
}
